// extracted by mini-css-extract-plugin
export default {"card-icon":"teams-view_card-icon__86HTG"};